<template>
  <div class="service-center" v-track="{ act: 'ready', data: { id: 436, p: [] } }">
    <my-header showBack></my-header>
    <div class="consult-wrap">
      <a class="online" @click="toCustomerService" v-track="{ act: 'click', data: { id: 437, p: [] } }">
        <div class="online-icon">
          <img src="../../../image/card/service/kf.png" alt="客服咨询" />
        </div>
        <span>客服咨询</span>
      </a>
      <a href="tel:4001808400" class="phone" v-track="{ act: 'click', data: { id: 438, p: [] } }">
        <div class="phone-icon">
          <img src="../../../image/card/service/dianhua.png" alt="电话咨询" />
        </div>
        <span>电话咨询</span>
      </a>
    </div>
    <div class="consult-time">咨询时间：09:00 - 22:30</div>
    <div class="question-wrap" v-show="list.length">
      <div class="title">猜你想问：</div>
      <div class="item" v-for="(item, index) in list" :key="index" @click="toInfo(item.helpId)" v-track="{ act: 'click', data: { id: 439, p: [item.helpId] } }">
        {{ item.question }}
        <div class="item-right">
          <Icon size="11">quanju_fanhui</Icon>
        </div>
      </div>
    </div>
    <div class="feedback" @click="toFeedback">
      <img src="../../../image/card/service/edit.png" width="15px" height="15px" alt />
      <span class="feedback-btn" v-track="{ act: 'click', data: { id: 440, p: [] } }">意见反馈</span>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

import Icon from '../../components/icon'
import MyHeader from '../../components/header'
import { toCustomerService } from '../../util/kf'

export default {
  data() {
    return {}
  },
  mounted() {
    if (this.hasMore) {
      this.getServiceQuestionList(this.page)
    }
    // 客服话务地址
    this.getServiceUrl()
  },
  components: {
    Icon,
    MyHeader,
  },
  methods: {
    ...mapActions(['getServiceQuestionList']),
    toInfo(id) {
      this.$router.push({
        path: `/service/info/${id}`,
      })
    },
    toFeedback() {
      this.$router.push({
        path: `/center/setting?isFeedback=1`,
      })
    },
    toCustomerService() {
      toCustomerService(this.serviceUrl)
    },
    onLoadMore() {
      if (this.hasMore) {
        this.getServiceQuestionList({
          type: this.page.type,
          pageNum: this.page.pageNum + 1,
          pageSize: this.page.pageSize,
        })
      }
    },
    getServiceUrl() {
      this.$store.dispatch('getServiceUrl')
    },
  },
  computed: {
    ...mapState({
      list: state => state.service.questions || [],
      hasMore: state => state.service.hasMore,
      page: state => state.service.page,
      serviceUrl: state => state.service.serviceUrl,
    }),
  },
}
</script>
<style lang="less" scoped>
@import '../../../stylesheet/variable';
@bgColor: rgb(255, 240, 227);
.service-center {
  color: rgb(25, 26, 27);
  font-size: 14px;
  min-height: calc(~'100vh - 44px');
  padding-bottom: 44px;
  position: relative;
  top: 44px;
  background: #fff;
  .consult-wrap {
    width: 100%;
    height: 153px;
    position: relative;
    background-color: #fff;
    display: flex;
    align-items: center;
    &::after {
      .setBottomLine();
    }
    a {
      outline: none;
      // float: left;
      // width: 50%;
      // text-align: center;
      // display: inline-block;
      display: flex;
      align-items: center;
      flex-direction: column;
      flex: 1;
      img {
        width: 92px;
        height: 90px;
      }
      span {
        font-size: 13px;
      }
    }
  }
  .consult-time {
    height: 32px;
    line-height: 32px;
    text-align: center;
    font-size: 13px;
    background-color: @bgColor;
    color: @orange;
  }
  .question-wrap {
    background-color: #fff;
    .title {
      height: 44px;
      margin: 0 15px;
      line-height: 44px;
      position: relative;
      color: @steelGrey;
      font-size: 12px;
      letter-spacing: -0.14px;
      &::after {
        .setBottomLine();
      }
    }
    .item {
      margin: 0 15px;
      height: 44px;
      line-height: 44px;
      position: relative;
      &::after {
        .setBottomLine();
      }
      .item-right {
        float: right;
        transform: rotateY(180deg);
        height: 44px;
      }
    }
  }
  .feedback {
    background-color: #fff;
    margin: 40px auto;
    width: 150px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    position: relative;
    color: @orange;

    &::after {
      .setBorderLine(@orange);
    }
    .feedback-btn {
      font-size: 16px;
    }
  }
}
</style>
